import { TUTOR_LESSONS_ROUTE } from "../../app/router/routes";
import { TutorLessons } from "../../widgets/tutorLessons";
import { LayoutPages } from "../layoutPages";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../app/store/store";
import { FEATURES, hasFeature } from "../../entities/my";
import { HOME_ROUTE } from "../../app/router/routes";

export default function TutorLessonsPage() {
    const {my} = useAppSelector(s => s.myReducer)

    if(!hasFeature(my, FEATURES.LESSONS.TUTOR_LIST, my.id)){
        return <Navigate to={HOME_ROUTE.path} replace />
    }

    return (
        <LayoutPages title={TUTOR_LESSONS_ROUTE.name}>
            <TutorLessons  />
        </LayoutPages>
    )
}
